export class Multiplier{
    cpt1:number = 0;
    cpt2:number = 0;
    cpt3:number = 0;
    cpt4:number = 0;
    cpt5:number = 0;
    cpt6:number = 0;
    cpt7:number = 0;
    cpt8:number = 0;
}